export default __webpack_public_path__ + "static/media/SAML_New_Application.1e1461ac.png";